import { __rest } from 'tslib';
import React from 'react';
import useDevice from '../../../hooks/useDevice.mjs';
import theme, { Size } from '../../../styles/theme.mjs';
import ButtonComponent from '../../Basic/Button/Button.mjs';
import { PlayIcon } from '../../Basic/Icons/ButtonIcons/ButtonIcons.mjs';
import { ProgressButton } from '../ProgressButton/ProgressButton.mjs';
import { StyledContainer, StyledOverlay, StyledMediaCard, StyledSmallMediaCard, ControlsContainer } from './VideoEndOverlay.styles.mjs';

const VideoEndOverlay = (_a) => {
    var { playNextHref, playNextAfter, onCancelClick } = _a, mediaCardProps = __rest(_a, ["playNextHref", "playNextAfter", "onCancelClick"]);
    const { isMobile: isBelowSm } = useDevice('sm');
    const { isMobile: isBelowXl } = useDevice('xl');
    return (React.createElement(StyledContainer, null,
        React.createElement(StyledOverlay, { direction: "column", alignItems: "center", justifyContent: "center", className: "next-video" },
            !isBelowSm ? (React.createElement(StyledMediaCard, Object.assign({}, mediaCardProps))) : (React.createElement(StyledSmallMediaCard, Object.assign({}, mediaCardProps))),
            React.createElement(ControlsContainer, { margin: { default: '2rem auto 0', md: '1rem auto 0', xl: '2rem auto 0' }, padding: "0" },
                React.createElement(ButtonComponent, { variant: "secondary", type: "button", size: isBelowXl ? Size.Small : Size.Regular, ariaLabel: "Cancel next video autoplay", className: "cancel-autoplay-button", onClick: onCancelClick }, "Cancel"),
                React.createElement(ProgressButton, { size: isBelowXl ? Size.Small : Size.Regular, ariaLabel: "Play next video", href: playNextHref, className: "play-next-button", playNextAfter: playNextAfter },
                    React.createElement(PlayIcon, { color: theme.colors.slate }),
                    " Next video")))));
};

export { VideoEndOverlay as default };
//# sourceMappingURL=VideoEndOverlay.mjs.map
